export const managerUsers = {
  usersList: {
    title: "Registered users",
    subtitle: "List of users registered on the platform.",
    columns: {
      id: "ID",
      name: "Name",
      phone: "Phone",
      email: "Email",
      accommodations: "Accommodations",
      sends: "Sends",
      checkin: "Check-in",
      registeredAt: "Registration date",
    },
    states: {
      demo: "Demo version",
      demoEnded: "Demo ended",
      subscribed: "Subscribed",
      subscriptionExpired: "Subscription expired",
      queryError: "Query error",
    },
    deleteAdvisor: {
      confirmMessage: "Are you sure you want to delete this advisor?",
      confirmHeader: "Confirm",
    },
  },
  accommodationUser: {
    info: "Accommodation details",
  },
  dataUserOld: {
    accommodationsList: "Accommodations list",
    createAccommodation: "Create accommodation",
    emptyMessage: "No accommodations registered",
    emptySubMessage: "The accommodations registered by the user will appear here.",
  },
  checkins: {
    title: "Completed check-ins",
  },
  checkinsPending: {
    title: "Pending or in-progress check-ins",
  },
};
